import React, { useEffect } from 'react';
import { Helmet } from "react-helmet";

import Proptype from 'prop-types';

export const PageMeta = ({
    title,
    children,
    removeDescriptionTag,
    useSocialMediaTags,
    previewImg,
    description
}) => {

    useEffect(() => {
        if (removeDescriptionTag) {
            // We need to remove current meta description tag, not the one created by Helmet
            const currentDescriptionTag = document.querySelector(`meta[name="description"]:not([data-react-helmet="true"])`);

            if (currentDescriptionTag) {
                document.head.removeChild(currentDescriptionTag);
            }
        }

    }, []);

    return useSocialMediaTags ? (
        <Helmet>
            <title>{title}</title>
            {children}
            {/* Facebook Meta tags */}
            <meta property="og:image" content={`${previewImg}`}/>
            <meta property="og:title" content={`${title}`}/>
            <meta property="og:description" content={description}/>
            <meta property="og:site_name" content="The Noun Project" />
            <meta property="og:type" content="website"/>

            {/* Twitter meta tags */}
            <meta name="twitter:card" content="summary"/>
            <meta name="twitter:site" content="@nounproject"/>
            <meta name="twitter:title" content={`${title}`}/>
            <meta name="twitter:description" content={description}/>
            <meta name="twitter:image:src" content={`${previewImg}`}/>
            <meta name="twitter:domain" content="https://thenounproject.com"/>
        </Helmet>
    ) : (
        <Helmet>
            <title>{title}</title>
            {children}
        </Helmet>
    );
};

PageMeta.propTypes = {
    title: Proptype.string.isRequired,
    removeDescriptionTag: Proptype.bool,
    useSocialMediaTags: Proptype.bool,
    previewImg: Proptype.string,
    description: Proptype.string,
    children: Proptype.any
};
export default PageMeta;
